import { useState } from 'react';

export default function useBlockScroll() {
  const [offSet, setOffSet] = useState(0);

  return function blockScroll(block) {
    if (block) {
      const offsetY = window.pageYOffset;
      document.body.classList.add('block-scroll');
      document.body.scrollTop = offsetY;
      setOffSet(offsetY);
    } else {
      document.body.classList.remove('block-scroll');
      window.scrollTo(0, offSet);
    }
  };
}
